import * as React from 'react';
import { DetailFormTask } from '../components/DetailFormTask';
export const DetailTask = () => {
  return <DetailFormTask />;
};
